import { render } from "./OrderDetailsShimmer.vue?vue&type=template&id=1097d79c"
import script from "./OrderDetailsShimmer.vue?vue&type=script&lang=js"
export * from "./OrderDetailsShimmer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__